/**
 * @param seconds The number of seconds to display
 * @param longForm whether the words hours/minutes/seconds should be spelled out, or just use the numbers
 * @returns Readable text for an amount of time
 */
export const getTimeDisplay = (seconds: number, longForm = true): string => {
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const minutesAmount = minutes - hours * 60;
  let result = "";
  if (hours > 0) {
    if (longForm) {
      result += `${hours} Hour${hours === 1 ? "" : "s"}, `;
    } else {
      result += `${hours}:`;
    }
  }
  if (hours > 0 || minutesAmount > 0) {
    if (longForm) {
      result += `${minutesAmount} Minute${minutesAmount === 1 ? "" : "s"}, `;
    } else {
      result += `${minutesAmount < 10 && hours > 0 ? "0" : ""}${minutesAmount}:`;
    }
  }
  const newSeconds = seconds % 60;
  const secondsAmount = newSeconds.toFixed(1);
  if (longForm) {
    result += `${secondsAmount} Seconds`;
  } else {
    result += `${newSeconds < 10 && minutes > 0 ? "0" : ""}${secondsAmount}`;
  }
  return result;
};
